import { render, staticRenderFns } from "./CountrySummary.vue?vue&type=template&id=957efbec&scoped=true"
import script from "./CountrySummary.vue?vue&type=script&lang=js"
export * from "./CountrySummary.vue?vue&type=script&lang=js"
import style0 from "./CountrySummary.vue?vue&type=style&index=0&id=957efbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957efbec",
  null
  
)

export default component.exports